import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import bets from './modules/bets';
import fight from './modules/fight';
import general from './modules/general';
import ticket from './modules/ticket';
import jackpot from './modules/jackpot';
import menu from './modules/menu';
import announcement from './modules/announcement';
import schedule from './modules/schedule';
import taiXiu from './modules/tai-xiu';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: sessionStorage,
  reducer: (state: any) => {
    return {
      general: state.general,
      bets: state.bets,
    };
  },
});

export default new Vuex.Store({
  modules: {
    fight,
    bets,
    general,
    ticket,
    jackpot,
    menu,
    announcement,
    schedule,
    taiXiu,
  },
  plugins: [vuexLocal.plugin],
});
